function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $ffc74d367f297e81$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"7pTZJ":"index.912c64fa.js","bW8Dt":"image1.a2f76ef8.png","ieA6E":"image1_2x.38f37bee.png","gwhdz":"image2.32168d70.png","htuuK":"image2_2x.06900880.png","lFRnR":"image3.237e22ae.png","6vbps":"image3_2x.032ee678.png","hfZZ9":"image4.9b5889b4.png","anDEB":"image4_2x.086ec6e2.png","guv9H":"image5.4459924d.png","gV3P6":"image5_2x.cba46041.png","9NAah":"image6.6990d88b.png","4nfsP":"image6_2x.2e43d496.png","3N2c0":"image7.181cb1fa.png","iQTjB":"image7_2x.51cb4288.png","9jEGL":"image8.88cae6e7.png","gxAyA":"image8_2x.7c961cd5.png","kaT8J":"image9.15050564.png","4gaJZ":"image9_2x.23d680cd.png","7aOuY":"amazon1.875cac08.png","33UjE":"applebook1.09bf885c.png","jjvJg":"barnesnoble.84820a41.png","gB3Gx":"amazon@1x.100eb040.png","6p5Hd":"amazon@2x.fdf8ae2a.png","gLOvi":"applebook@1x.58f7dd67.png","ltMyQ":"applebook@2x.1c1863b9.png","kJVOm":"barnesnoble@1x.e62c1f9d.png","8ZirL":"barnesnoble@2x.84820a41.png"}'));


//# sourceMappingURL=index.3b688de3.js.map
